<div  class="navigation-container d-flex justify-content-between align-items-center pl-3">
    <div class="d-flex align-items-center justify-content-start" (click)="goBack()">
        <mat-icon class="mr-3 pointer">keyboard_arrow_left</mat-icon>
        <span class="pointer">{{'general.back'|translate}}</span>
    </div>
    <span *ngIf="step" class="pr-4 steps">{{'general.step'|translate:{value:step} }} </span>
</div>
